// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAbx1ulXd6ZqWmNBVmLyNNGxHS2eOEoKM0",  // Updated API key
  authDomain: "taskify-4b4fc.firebaseapp.com",
  projectId: "taskify-4b4fc",
  storageBucket: "taskify-4b4fc.firestorage.app",
  messagingSenderId: "805184946863",
  appId: "1:805184946863:web:ab8ec2ffd42c18c61f8a5a",
  measurementId: "G-1VC799CDBK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, analytics };